import { LegalAttributeValue } from "../../../../../api/types"
import {
  ObjectValidatorsMap,
  ObjectMapValidator
} from "../../../../../components/Validator"

function isInteger(value: string) {
  return (
    !isNaN(+value) &&
    Number.isSafeInteger(+value) &&
    +value % 1 === 0 &&
    +value >= -2147483648 &&
    +value <= 2147483647
  )
}

const rangeIntegerValidator = (message: string) => (
  id: string,
  value: {
    value: string
    min?: string
    max?: string
  }
) => {
  if (isInteger(value.value)) {
    if (
      (value.value.length > 0 && value.max && +value.max < +value.value) ||
      (value.value.length > 0 && value.min && +value.min > +value.value)
    ) {
      return {
        valid: false,
        message,
        id
      }
    } else {
      return { valid: true }
    }
  } else {
    return {
      valid: false,
      message,
      id
    }
  }
}

const NumberValidatorMap: ObjectValidatorsMap<LegalAttributeValue> = {
  min: rangeIntegerValidator(
    "The value must be a valid number with a minimum value of -2147483648 and smaller than the given default/maximum value."
  ),
  max: rangeIntegerValidator(
    "The value must be a valid number with a maximum value of 2147483647 and larger than the given minimum/default value."
  ),
  default: rangeIntegerValidator(
    "The value must be a valid number between the given minimum and maximum values."
  )
}

const NumberValidator = new ObjectMapValidator<LegalAttributeValue>(
  NumberValidatorMap
)

export default NumberValidator
